import React, { Component, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";
import { Curve, NewBackButton } from "../../../components/svgs";
import ReactPlayer from "react-player/youtube";
import { io } from "socket.io-client";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

// theme
import { useTheme, useLoyalty, useAuth } from "../../../hooks";
import Comment from "../../../components/events/comment";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const LiveStream = () => {
  let history = useHistory();
  const { themeContext, theme } = useTheme();
  const { phoneNumber } = useAuth();
  const {
    selectedEvent,
    qnABanner,
    qnATitle,
    fetchPreviousLiveComments,
    commentsArray,
    submitLiveComment,
    setCommentsArray,
    askQuestion,
  } = useLoyalty();

  // const selectedEvent = {
  //   name: "YPYC Transform Summit 23",
  //   _id: "123456",
  //   thumbnailUri: `${SERVER_URL}/assests/imagesypyc-cover0623.jpeg`,
  //   streamingUri: "https://www.youtube.com/watch?v=DngKICmGWB8",
  // };

  // const eventId = "6229e2fd1e0b23b5dad656cd";

  const [comment, setComment] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [commentValid, setCommentValid] = useState(false);
  const [liveComment, setLiveComment] = useState("");
  const [liveComments, setLiveComments] = useState([]);
  const [socketMessage, setSocketMessage] = useState({});
  const [showHeaderCommentInput, setShowHeaderCommentInput] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [socketConnection, setSocketConnection] = useState(null);

  const commentRef = useRef(null);

  useEffect(() => {
    if (selectedEvent) {
      setEventId(selectedEvent._id);
    }
  }, [selectedEvent]);

  const scrollHandler = () => {
    if (commentRef.current) {
      const element = commentRef.current;
      element.scroll({
        top: commentRef.current.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "LiveStream",
        firebase_screen_class: "LiveStream",
      })
    );
    // Connect to socket
    const socket = io(process.env.SOCKET_HOST, {
      transports: ["polling"],
    });
    socket.on("connect", () => {});

    socket.on("connect_error", (msg) => {
      setTimeout(() => {
        socket.connect();
      }, 1000);
    });
    setSocketConnection(socket);

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (eventId) {
      socketConnection?.on(eventId, (msg) => {
        setSocketMessage(msg);
      });
    }
    fetchPreviousLiveComments(eventId);
  }, [eventId, socketConnection]);

  useEffect(() => {
    scrollHandler();
  }, [liveComments]);

  useEffect(() => {
    if (commentsArray) {
      setLiveComments(commentsArray);
    }
  }, [commentsArray]);

  const updateComments = (msg) => {
    const newArray = [...liveComments, msg];

    setLiveComments(newArray);
    scrollHandler();
  };

  useEffect(() => {
    updateComments(socketMessage);
  }, [socketMessage.createdAt]);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  const MTNBlue = "#00678F";
  return (
    <>
      <MainHolder activeTheme={mashupBackground}>
        <Children>
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          {!comment ? (
            <>
              {selectedEvent.name === "Pulse Hangout" ? (
                <>
                  <Gradient>
                    <Image src={selectedEvent?.thumbnailUri} />
                    <GradientBody>
                      <HeaderContent>
                        <StyledText
                          size={24}
                          color={"white"}
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            fontFamily: "MTNMedium",
                            width: "100%",
                          }}
                        >
                          {selectedEvent?.name}
                        </StyledText>
                      </HeaderContent>
                    </GradientBody>
                  </Gradient>
                  <DescriptionBody color={mashupBackground}>
                    <CurveHolder>
                      <Curve fill={MTNBlue} />
                    </CurveHolder>
                    <CurveContent>
                      <StyledText
                        size={24}
                        color={"white"}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          fontFamily: "MTNMedium",
                          width: "100%",
                        }}
                      >
                        {"26th June"}
                      </StyledText>
                      <StyledText
                        size={14}
                        color={"white"}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          fontFamily: "MTNMedium",
                          width: "100%",
                        }}
                      >
                        {"Live at 19:00"}
                      </StyledText>
                    </CurveContent>
                    <CurveHolder>
                      <Curve fill={mashupBackground} />
                    </CurveHolder>
                    <ContentHolder>
                      <StyledText
                        size={24}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          fontFamily: "MTNMedium",
                          width: "100%",
                          marginLeft: "5%",
                        }}
                      >
                        {qnATitle}
                      </StyledText>
                      <QnAButton
                        src={qnABanner}
                        onClick={(e) => {
                          e.preventDefault();
                          setComment(true);
                        }}
                      />
                    </ContentHolder>
                  </DescriptionBody>
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: showHeaderCommentInput ? "block" : "none",
                    }}
                  >
                    {/* <TopCommentInput
                      type={"text"}
                      placeholder='write a comment'
                      value={liveComment}
                      onChange={(e) => {
                        setLiveComment(e.target.value);
                      }}
                    /> */}
                    <TopSubmitButton
                      onClick={(e) => {
                        e.preventDefault();
                        let msisdn = `233${phoneNumber?.substring(1)}`;
                        if (liveComment !== "") {
                          const payload = {
                            comment: liveComment,
                            eventId,
                            msisdn,
                          };
                          setLiveComment("");
                          submitLiveComment(payload);
                          setShowHeaderCommentInput(false);
                          scrollHandler();
                        }
                      }}
                    >
                      <StyledText size={12}>{">"}</StyledText>
                    </TopSubmitButton>
                    <HideCommentInputButton
                      onClick={() => setShowHeaderCommentInput(false)}
                    >
                      Hide
                    </HideCommentInputButton>
                  </div>

                  <PlayerHolder>
                    {selectedEvent?.streamingUriSrc === "facebook" ? (
                      <FacebookPlayer selectedEvent={selectedEvent} />
                    ) : (
                      <ReactPlayer
                        url={selectedEvent?.streamingUri}
                        controls={true}
                        width={"100%"}
                        style={{
                          width: "100%",
                          height: "47%",
                        }}
                      />
                    )}
                    <VideoTitleHolder>
                      <StyledText
                        size={18}
                        color={"white"}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          fontFamily: "MTNMedium",
                          width: "100%",
                        }}
                      >
                        {selectedEvent.name}
                      </StyledText>
                    </VideoTitleHolder>
                    <CommentSection ref={commentRef}>
                      {Array.isArray(liveComments) &&
                        liveComments?.map((liveComment) => {
                          const { comment, msisdn, createdAt, userProfile } =
                            liveComment || {};
                          let username = msisdn;
                          let profilePhoto = null;
                          if (Array.isArray(userProfile)) {
                            if (userProfile.length) {
                              username = userProfile[0].username;
                              profilePhoto = userProfile[0].photoUrlThumbnail;
                            }
                          }

                          return (
                            <>
                              {comment !== undefined && comment !== null && (
                                <Comment
                                  comment={comment}
                                  msisdn={username}
                                  profilePhoto={profilePhoto}
                                  createdAt={createdAt}
                                />
                              )}
                            </>
                          );
                        })}
                      {/* <LiveCommentInput
                        onFocus={() => {
                          setShowHeaderCommentInput(true);
                        }}
                        type={"text"}
                        placeholder='write a comment'
                        value={liveComment}
                        onChange={(e) => {
                          setLiveComment(e.target.value);
                        }}
                      /> */}
                      {/* <SubmitButton
                        onClick={(e) => {
                          e.preventDefault();
                          let msisdn = `233${phoneNumber?.substring(1)}`;
                          if (liveComment !== "") {
                            const payload = {
                              comment: liveComment,
                              eventId,
                              msisdn,
                            };
                            setLiveComment("");
                            submitLiveComment(payload);
                            setShowHeaderCommentInput(false);
                            scrollHandler();
                          }
                        }}
                      >
                        <StyledText size={12}>{">"}</StyledText>
                      </SubmitButton> */}
                    </CommentSection>
                  </PlayerHolder>
                </>
              )}
            </>
          ) : (
            <>
              <CommentBody>
                <CommentInput
                  type='text'
                  value={commentText}
                  onChange={(e) => {
                    setCommentText(e.target.value);
                    if (e.target.value.length >= 5) {
                      setCommentValid(true);
                    }
                  }}
                  placeholder='Type your question/comment/statement you like to ask favourite celebrity coming on the show'
                />
                <Button
                  onClick={(e) => {
                    setComment(false);
                    e.preventDefault();
                    let msisdn = `233${phoneNumber?.substring(1)}`;
                    const payload = { question: commentText, eventId, msisdn };
                    askQuestion(payload);

                    setCommentText("");
                  }}
                  style={{ marginInline: 20 }}
                  color={background}
                  disabled={!commentValid}
                >
                  <StyledText color={"white"}>{"submit"}</StyledText>
                </Button>
              </CommentBody>
            </>
          )}
        </Children>
      </MainHolder>
    </>
  );
};

const FacebookPlayer = ({ selectedEvent }) => {
  return (
    <iframe
      title={selectedEvent.name}
      src={selectedEvent?.streamingUri}
      width='100%'
      height='auto'
      style={{ border: "none", overflow: "hidden", height: "auto" }}
      allowFullscreen='false'
      allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
    ></iframe>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: inherit;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  margin: 20px;
  z-index: 2;
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
  position: absolute;
`;

const Gradient = styled.div`
  width: 100%;
  height: 360px;
  position: relative;
`;

const GradientBody = styled.div`
  position: absolute;
  height: 360px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
`;

const HeaderContent = styled.div`
  display: flex;
  padding: 8%;
  flex-direction: column;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  z-index: 2;
  position: relative;
`;

const CurveContent = styled.div`
  width: 100%;
  background-color: #00678f;
  padding: 10%;
  margin-top: -7%;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ContentHolder = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 8%;
`;

const QnAButton = styled.img`
  height: 95px;
  width: 80%;
  border-radius: 10px;
  margin-top: 15px;
`;

const CommentBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20%;
  flex-direction: column;
  height: 80%;
`;

const CommentInput = styled.textarea`
  width: 85%;
  height: 170px;
  border-radius: 10px;
  border-color: #c8cbcb;
  border-width: 1px;
  padding: 10px;
  font-family: MTNRegular;
  align-self: center;
`;

const PlayerHolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const VideoTitleHolder = styled.div`
  background-color: #00678f;
  padding: 3%;
  display: flex;
  flex-direction: column;
  text-align: center;
  max-height: 5%;
`;

const CommentSection = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  height: 48%;
  /* background-color: green; */
  flex-direction: column;
  overflow: scroll;
  margin-bottom: 30px;
`;

const TopCommentInput = styled.input`
  display: flex;
  /* width: 100%; */
  height: 20px;
  z-index: 2;
  border-color: #c8cbcb;
  border-width: 1px;
  padding: 10px;
  font-family: MTNRegular;
  align-self: flex-end;
  justify-self: flex-end;
  position: absolute;
  margin: 0px;
  right: 0px;
  left: 0px;
  top: 0px;
  padding-right: 50px;
`;

const LiveCommentInput = styled.input`
  display: flex;
  /* width: 100%; */
  height: 20px;
  border-color: #c8cbcb;
  border-width: 1px;
  padding: 10px;
  font-family: MTNRegular;
  align-self: flex-end;
  justify-self: flex-end;
  position: absolute;
  margin: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  padding-right: 50px;
`;

const TopSubmitButton = styled.div`
  padding: 2px;
  border-radius: 15px;
  background-color: #ffcc00;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 3;
  align-self: flex-end;
  justify-self: flex-end;
  right: 0px;
  top: 10px;
  margin-right: 8px;
  margin-bottom: 11px;
`;

const SubmitButton = styled.div`
  padding: 2px;
  border-radius: 15px;
  background-color: #ffcc00;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  align-self: flex-end;
  justify-self: flex-end;
  right: 0px;
  bottom: 0px;
  margin-right: 8px;
  margin-bottom: 11px;
`;

const HideCommentInputButton = styled.div`
  font-family: MTNRegular;
  position: absolute;
  top: 45px;
  background: rgba(0, 0, 0, 0.5);
  color: rgb(255, 255, 255);
  display: block;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 50px;
  text-align: center;
  border-radius: 0px 0px 16px 16px;
  padding: 5px 10px;
`;

export default LiveStream;
